module.exports = __webpack_public_path__ + "static/img/default.8602fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/default.png
// module id = 541
// module chunks = 382